import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import "./ProductaddreviewPage.css";
import { Rating } from "react-simple-star-rating";
import { postRequestcall } from "../../comman/util/postRequest";
import { RATING } from "../../constants/apiurl";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ButtonPage from "../../comman/button/ButtonPage";
import FormgroupPage from "../../comman/formgroup/FormgroupPage";

function ProductaddreviewPage(props) {
  let getpid = window.location.pathname.split("/").pop();
  const { t } = useTranslation();
  const [writereview, setWitereview] = useState({
    review: "",
    rating: 0,
  });
  const [rating, setRating] = useState(0); // initial rating value
  // Catch Rating value
  const handleRating = (rate) => {
    setRating(rate);
    let rating;
    console.log("rate * 20", rate * 20)
    switch (rate * 20) {
      case 10:
        rating = 0.5;
        break;
      case 20:
        rating = 1;
        break;
      case 30:
        rating = 1.5;
        break;
      case 40:
        rating = 2;
        break;
      case 50:
        rating = 2.5;
        break;
      case 60:
        rating = 3;
        break;
      case 70:
        rating = 3.5;
        break;
      case 80:
        rating = 4;
        break;
      case 90:
        rating = 4.5;
        break;
      case 100:
        rating = 5;
        break;
      default:
        break;
    }
    setWitereview({
      ...writereview,
      rating: rating,
    });
  };

  const reviewTextchange = (e) => {
    setWitereview({
      ...writereview,
      [e.target.name]: e.target.value,
    });
  };

  const submitReview = async () => {
    if (writereview.review !== "") {
      let geturl =
        RATING +
        `?product_id=${getpid}&id=${props?.productDetail?.store_id}&rating=${writereview.rating}&review=${writereview.review}`;
      let ratingResponse = await postRequestcall(
        geturl,
        props?.access_token,
        ""
      );
      if (ratingResponse?.status === 200) {
        toast.success(t('pages.Review submitted successfully'));
        props.getRating();
        setWitereview({
          review: "",
          rating: 0,
        });
        setRating(0);
        props.setProductreview(false);
      }
    } else {
      toast.error(t("pages.Please add review"));
    }
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props?.productreview}
      onHide={() => props.setProductreview(false)}
      className="review-modal"
    >
      <Modal.Body>
        <div className="review">
          <div className="review-header">
            <h5>{t("pages.Give your Reivew and Rating")}</h5>
            <Rating
              onClick={handleRating}
              ratingValue={rating}
              size={30}
              fillColor={"var(--pr-color)"}
              allowHalfIcon
            />
          </div>
          <div>
            <Form.Group className="form-group">
         <FormgroupPage as={"textarea"} style={{ height: "auto" }} rows={5}  placeholder={t("pages.Enter your review")} 
value={writereview.review} name={"review"} onChange={reviewTextchange} />
            </Form.Group>
          </div>
          <ButtonPage
              Text={t("pages.Submit Review")}
              onClick={() => submitReview()}
              className="button-review w-100 mt-2"
              type={"button"}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
});

export default connect(mapStateToProps)(ProductaddreviewPage);
